(() => {
  const SELECTORS = {
    gallery: '#AB-003-gallery',
    plan: '.plan-card',
    checkoutButton: '[data-checkout-button]',
    modal: '[data-ingredients-modal]',
    openModal: '[data-ingredients-open]',
    closeModal: '[data-ingredients-close]'
  };

  function initializeGallery(root = document) {
    const gallery = root.querySelector(SELECTORS.gallery);

    if (
      !gallery ||
      gallery.dataset.swiperInitialized === 'true' ||
      typeof window.Swiper === 'undefined'
    ) {
      return;
    }

    const thumbsElement = gallery.querySelector('.swiper_thumbs');
    const mainElement = gallery.querySelector('.swiper_main');

    if (!thumbsElement || !mainElement) {
      return;
    }

    const thumbnailSwiper = new window.Swiper(thumbsElement, {
      spaceBetween: 8,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true
    });

    const mainSwiper = new window.Swiper(mainElement, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: gallery.querySelector('.swiper-button-next'),
        prevEl: gallery.querySelector('.swiper-button-prev')
      },
      thumbs: {
        swiper: thumbnailSwiper
      },
      keyboard: {
        enabled: true
      }
    });

    gallery.dataset.swiperInitialized = 'true';
    gallery.mainSwiper = mainSwiper;
    gallery.thumbnailSwiper = thumbnailSwiper;
  }

  function initializeOffer(root = document) {
    const plans = Array.from(root.querySelectorAll(SELECTORS.plan));
    const checkoutButton = root.querySelector(SELECTORS.checkoutButton);

    if (!plans.length || !checkoutButton) {
      return;
    }

    function selectPlan(selectedPlan) {
      plans.forEach((plan) => {
        const isSelected = plan === selectedPlan;

        plan.classList.toggle('active', isSelected);
        plan.setAttribute('aria-pressed', String(isSelected));
      });

      checkoutButton.dataset.checkoutUrl =
        selectedPlan.dataset.checkoutUrl || '';
    }

    plans.forEach((plan) => {
      plan.addEventListener('click', () => {
        selectPlan(plan);
      });
    });

    const defaultPlan =
      plans.find((plan) => plan.classList.contains('active')) ||
      plans[0];

    selectPlan(defaultPlan);

    checkoutButton.addEventListener('click', () => {
      const checkoutUrl = checkoutButton.dataset.checkoutUrl;

      if (!checkoutUrl) {
        console.error('No checkout URL is configured.');
        return;
      }

      checkoutButton.disabled = true;
      checkoutButton.textContent = 'Loading…';

      /*
        window.location.assign(checkoutUrl) meant three chained top-level
        navigations (/cart/add → /checkout → /checkouts/cn/<token>), with the
        page torn down — and every analytics unload handler flushed — before
        the first one even started.

        HHCheckout.go performs the add as a fetch while this page is still
        alive and then does a single navigation, which removes a full round
        trip and lets the overlay paint immediately. It falls back to the
        original navigation if anything goes wrong, so the button always
        works even if the snippet failed to load.
      */
      if (window.HHCheckout) {
        window.HHCheckout.go(checkoutUrl);
      } else {
        window.location.assign(checkoutUrl);
      }
    });
  }

  function initializeIngredientModal(root = document) {
    const modal = root.querySelector(SELECTORS.modal);
    const openButton = root.querySelector(SELECTORS.openModal);

    if (!modal || !openButton) {
      return;
    }

    const closeButtons = modal.querySelectorAll(SELECTORS.closeModal);

    function openModal() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      modal.querySelector('.hh-modal__close')?.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';

      openButton.focus();
    }

    openButton.addEventListener('click', openModal);

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  }

  function initializePage(root = document) {
    initializeGallery(root);
    initializeOffer(root);
    initializeIngredientModal(root);
  }

  function waitForSwiper() {
    if (typeof window.Swiper !== 'undefined') {
      initializePage(document);
      return;
    }

    window.setTimeout(waitForSwiper, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiper);
  } else {
    waitForSwiper();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializePage(event.target);
  });
})();





/* =========================================================
   VIDEO REVIEWS SLIDER — START

   Responsibilities:
   - Finds the video slider and arrow buttons
   - Scrolls one card at a time
   - Starts muted autoplay videos
   - Prevents duplicate initialization in the Shopify editor
========================================================= */

function initializeVideoReviews(root = document) {
  const slider = root.querySelector('[data-video-slider]');
  const previousButton = root.querySelector('[data-video-slider-prev]');
  const nextButton = root.querySelector('[data-video-slider-next]');

  if (!slider || slider.dataset.initialized === 'true') {
    return;
  }

  const getScrollAmount = () => {
    const card = slider.querySelector('.video-card');

    if (!card) {
      return 0;
    }

    const styles = window.getComputedStyle(slider);
    const gap = parseFloat(styles.columnGap || styles.gap || '0');

    return card.getBoundingClientRect().width + gap;
  };

  previousButton?.addEventListener('click', () => {
    slider.scrollBy({
      left: -getScrollAmount(),
      behavior: 'smooth'
    });
  });

  nextButton?.addEventListener('click', () => {
    slider.scrollBy({
      left: getScrollAmount(),
      behavior: 'smooth'
    });
  });

  slider.querySelectorAll('video').forEach((video) => {
    video.muted = true;

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  });

  slider.dataset.initialized = 'true';
}

/* =========================================================
   VIDEO REVIEWS SLIDER — END
========================================================= */








/* =========================================================
   WHAT'S INSIDE EVERY BOTTLE ACCORDION — START

   Features:
   - Smooth opening and closing
   - Only one ingredient open at a time
   - Clicking an open item closes it
   - No hidden attribute
   - No CSS.escape dependency
   - No ResizeObserver dependency
   - Scoped to this section
   - Supports Shopify theme-editor reloads
========================================================= */

(() => {
  'use strict';

  const SECTION_SELECTOR = '[data-hh-bottle-section]';
  const ACCORDION_SELECTOR = '[data-hh-ingredient-accordion]';
  const TRIGGER_SELECTOR = '.hh-bottle-trigger';
  const PANEL_SELECTOR = '.hh-bottle-panel';

  /**
   * Returns the content panel controlled by a trigger.
   */
  function getControlledPanel(accordion, trigger) {
    const panelId = trigger.getAttribute('aria-controls');

    if (!panelId) {
      return null;
    }

    return accordion.querySelector(
      `[id="${panelId}"]`
    );
  }

  /**
   * Opens one accordion item.
   */
  function openIngredient(trigger, panel) {
    if (!trigger || !panel) {
      return;
    }

    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');

    /*
     * Start from the current height so the transition
     * remains smooth if the item is clicked rapidly.
     */
    panel.style.height = `${panel.scrollHeight}px`;

    const handleOpenTransitionEnd = (event) => {
      if (
        event.propertyName !== 'height' ||
        trigger.getAttribute('aria-expanded') !== 'true'
      ) {
        return;
      }

      /*
       * Auto height allows the panel to adapt if text
       * wraps differently after a viewport resize.
       */
      panel.style.height = 'auto';

      panel.removeEventListener(
        'transitionend',
        handleOpenTransitionEnd
      );
    };

    panel.addEventListener(
      'transitionend',
      handleOpenTransitionEnd
    );
  }

  /**
   * Closes one accordion item.
   */
  function closeIngredient(trigger, panel) {
    if (!trigger || !panel) {
      return;
    }

    trigger.setAttribute('aria-expanded', 'false');

    /*
     * When the panel is set to auto, first convert it
     * to its measured pixel height.
     */
    panel.style.height = `${panel.scrollHeight}px`;

    /*
     * Force the browser to register the measured height
     * before transitioning it down to zero.
     */
    panel.getBoundingClientRect();

    panel.style.height = '0px';
    panel.classList.remove('is-open');
  }

  /**
   * Initializes one accordion container.
   */
  function initializeAccordion(accordion) {
    if (
      !accordion ||
      accordion.dataset.hhAccordionReady === 'true'
    ) {
      return;
    }

    const triggers = Array.from(
      accordion.querySelectorAll(TRIGGER_SELECTOR)
    );

    /*
     * Establish a reliable closed state.
     */
    triggers.forEach((trigger) => {
      const panel = getControlledPanel(
        accordion,
        trigger
      );

      trigger.setAttribute(
        'aria-expanded',
        'false'
      );

      if (panel) {
        panel.classList.remove('is-open');
        panel.style.height = '0px';
      }
    });

    accordion.addEventListener('click', (event) => {
      const trigger = event.target.closest(
        TRIGGER_SELECTOR
      );

      if (
        !trigger ||
        !accordion.contains(trigger)
      ) {
        return;
      }

      const selectedPanel = getControlledPanel(
        accordion,
        trigger
      );

      if (!selectedPanel) {
        console.warn(
          'Ingredient panel not found for:',
          trigger.getAttribute('aria-controls')
        );

        return;
      }

      const selectedWasOpen =
        trigger.getAttribute('aria-expanded') ===
        'true';

      /*
       * Close every other item first.
       */
      triggers.forEach((otherTrigger) => {
        if (otherTrigger === trigger) {
          return;
        }

        const otherPanel = getControlledPanel(
          accordion,
          otherTrigger
        );

        if (
          otherTrigger.getAttribute(
            'aria-expanded'
          ) === 'true'
        ) {
          closeIngredient(
            otherTrigger,
            otherPanel
          );
        }
      });

      /*
       * Toggle the selected item.
       */
      if (selectedWasOpen) {
        closeIngredient(
          trigger,
          selectedPanel
        );
      } else {
        openIngredient(
          trigger,
          selectedPanel
        );
      }
    });

    accordion.dataset.hhAccordionReady = 'true';
  }

  /**
   * Initializes all bottle accordions within a root.
   */
  function initializeBottleSections(root = document) {
    const sections = [];

    if (
      root.matches &&
      root.matches(SECTION_SELECTOR)
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections.push(
        ...root.querySelectorAll(
          SECTION_SELECTOR
        )
      );
    }

    sections.forEach((section) => {
      const accordion = section.querySelector(
        ACCORDION_SELECTOR
      );

      initializeAccordion(accordion);
    });
  }

  /**
   * Standard page load.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeBottleSections(document);
      }
    );
  } else {
    initializeBottleSections(document);
  }

  /**
   * Shopify theme-editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeBottleSections(event.target);
    }
  );

  /**
   * Recalculate any open panel after resizing.
   */
  window.addEventListener('resize', () => {
    document
      .querySelectorAll(
        `${ACCORDION_SELECTOR} ${TRIGGER_SELECTOR}[aria-expanded="true"]`
      )
      .forEach((trigger) => {
        const accordion = trigger.closest(
          ACCORDION_SELECTOR
        );

        const panel = getControlledPanel(
          accordion,
          trigger
        );

        if (panel) {
          panel.style.height = 'auto';
        }
      });
  });
})();

/* =========================================================
   WHAT'S INSIDE EVERY BOTTLE ACCORDION — END
========================================================= */



/* =========================================================
   REAL RESULTS IMAGE TICKER — START

   Features:
   - Automatic continuous scrolling
   - Pauses while dragging
   - Pointer and touch support
   - Different desktop and mobile speeds
   - Shopify theme-editor reload support
========================================================= */

(() => {
  'use strict';

  const SECTION_SELECTOR = '[data-hh-real-results]';
  const TICKER_SELECTOR = '[data-hh-results-ticker]';
  const TRACK_SELECTOR = '[data-hh-results-ticker-track]';

  function initializeResultsTicker(section) {
    if (!section || section.dataset.hhResultsReady === 'true') {
      return;
    }

    const ticker = section.querySelector(TICKER_SELECTOR);
    const track = section.querySelector(TRACK_SELECTOR);

    if (!ticker || !track) {
      return;
    }

    let isDragging = false;
    let startX = 0;
    let startingTranslateX = 0;

    function setTickerSpeed() {
      const isMobile = window.innerWidth <= 600;

      track.style.setProperty(
        '--hh-results-ticker-duration',
        isMobile ? '40s' : '25s'
      );
    }

    function getCurrentTranslateX() {
      const transform = window
        .getComputedStyle(track)
        .getPropertyValue('transform');

      if (!transform || transform === 'none') {
        return 0;
      }

      try {
        const matrix = new DOMMatrixReadOnly(transform);
        return matrix.m41;
      } catch (error) {
        return 0;
      }
    }

    function startDrag(event) {
      isDragging = true;
      startX = event.clientX;
      startingTranslateX = getCurrentTranslateX();

      ticker.classList.add('is-dragging');
      track.style.animationPlayState = 'paused';

      if (ticker.setPointerCapture) {
        ticker.setPointerCapture(event.pointerId);
      }
    }

    function dragTicker(event) {
      if (!isDragging) {
        return;
      }

      const distance = event.clientX - startX;

      track.style.transform =
        `translateX(${startingTranslateX + distance}px)`;
    }

    function stopDrag() {
      if (!isDragging) {
        return;
      }

      isDragging = false;

      ticker.classList.remove('is-dragging');

      /*
       * Remove the temporary manual transform so the continuous
       * ticker animation can resume from its own animation cycle.
       */
      track.style.transform = '';
      track.style.animationPlayState = 'running';
    }

    ticker.addEventListener('pointerdown', startDrag);
    ticker.addEventListener('pointermove', dragTicker);
    ticker.addEventListener('pointerup', stopDrag);
    ticker.addEventListener('pointercancel', stopDrag);
    ticker.addEventListener('pointerleave', stopDrag);

    setTickerSpeed();

    window.addEventListener('resize', setTickerSpeed);

    section.dataset.hhResultsReady = 'true';
  }

  function initializeResultsSections(root = document) {
    const sections = [];

    if (
      root.matches &&
      root.matches(SECTION_SELECTOR)
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections.push(
        ...root.querySelectorAll(SECTION_SELECTOR)
      );
    }

    sections.forEach(initializeResultsTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeResultsSections(document);
      }
    );
  } else {
    initializeResultsSections(document);
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeResultsSections(event.target);
    }
  );
})();

/* =========================================================
   REAL RESULTS IMAGE TICKER — END
========================================================= */





/* =========================================================
   FREQUENTLY ASKED QUESTIONS ACCORDION — START

   Features:
   - Answers display correctly
   - Smooth opening and closing
   - First two FAQs remain open on initial load
   - Multiple FAQs can remain open
   - Works in Shopify's theme editor
   - Prevents duplicate initialization
========================================================= */

(() => {
  'use strict';

  const SECTION_SELECTOR = '[data-hh-faq-section]';
  const ITEM_SELECTOR = '[data-hh-faq-item]';
  const QUESTION_SELECTOR = '.hh-faq-question';
  const PANEL_SELECTOR = '.hh-faq-panel';

  /**
   * Opens one FAQ item.
   */
  function openFaq(item, panel) {
    if (!item || !panel) {
      return;
    }

    item.open = true;
    panel.classList.add('is-open');
    panel.style.maxHeight = '0px';

    window.requestAnimationFrame(() => {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
    });
  }

  /**
   * Closes one FAQ item.
   */
  function closeFaq(item, panel) {
    if (!item || !panel) {
      return;
    }

    /*
     * Begin at the panel's current measured height.
     */
    panel.style.maxHeight = `${panel.scrollHeight}px`;

    /*
     * Force the browser to register the starting height.
     */
    panel.getBoundingClientRect();

    panel.style.maxHeight = '0px';
    panel.classList.remove('is-open');

    const handleCloseEnd = (event) => {
      if (event.propertyName !== 'max-height') {
        return;
      }

      item.open = false;

      panel.removeEventListener(
        'transitionend',
        handleCloseEnd
      );
    };

    panel.addEventListener(
      'transitionend',
      handleCloseEnd
    );
  }

  /**
   * Initializes a single FAQ section.
   */
  function initializeFaqSection(section) {
    if (
      !section ||
      section.dataset.hhFaqReady === 'true'
    ) {
      return;
    }

    const items = Array.from(
      section.querySelectorAll(ITEM_SELECTOR)
    );

    items.forEach((item) => {
      const question = item.querySelector(
        QUESTION_SELECTOR
      );

      const panel = item.querySelector(
        PANEL_SELECTOR
      );

      if (!question || !panel) {
        return;
      }

      /*
       * Preserve the HTML open attribute.
       * Your first two FAQ items include open by default.
       */
      if (item.open) {
        panel.classList.add('is-open');
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      } else {
        panel.classList.remove('is-open');
        panel.style.maxHeight = '0px';
      }

      question.addEventListener('click', (event) => {
        event.preventDefault();

        const isOpen = item.open;

        if (isOpen) {
          closeFaq(item, panel);
        } else {
          openFaq(item, panel);
        }
      });
    });

    section.dataset.hhFaqReady = 'true';
  }

  /**
   * Finds and initializes all FAQ sections inside a root.
   */
  function initializeFaqSections(root = document) {
    const sections = [];

    if (
      root.matches &&
      root.matches(SECTION_SELECTOR)
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections.push(
        ...root.querySelectorAll(SECTION_SELECTOR)
      );
    }

    sections.forEach(initializeFaqSection);
  }

  /**
   * Standard page load.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeFaqSections(document);
      }
    );
  } else {
    initializeFaqSections(document);
  }

  /**
   * Shopify theme-editor section reload.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeFaqSections(event.target);
    }
  );

  /**
   * Update the height of open answers after resizing.
   */
  window.addEventListener('resize', () => {
    document
      .querySelectorAll(
        `${ITEM_SELECTOR}[open] ${PANEL_SELECTOR}`
      )
      .forEach((panel) => {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      });
  });
})();

/* =========================================================
   FREQUENTLY ASKED QUESTIONS ACCORDION — END
========================================================= */




/* =========================================================
   FEATURE BENEFITS TICKER — START

   Features:
   - Safe to use multiple times on one page
   - Builds enough content to cover wide screens
   - Creates two identical halves for a seamless loop
   - Rebuilds correctly in Shopify's theme editor
   - Prevents duplicate initialization
========================================================= */

(() => {
  'use strict';

  const TICKER_SELECTOR =
    '[data-hh-feature-ticker]';

  const TRACK_SELECTOR =
    '[data-hh-feature-ticker-track]';

  const UNIT_SELECTOR =
    '[data-hh-feature-ticker-unit]';

  /**
   * Builds one ticker.
   */
  function initializeFeatureTicker(ticker) {
    if (
      !ticker ||
      ticker.dataset.hhFeatureTickerReady ===
        'true'
    ) {
      return;
    }

    const viewport = ticker.querySelector(
      '.hh-feature-ticker-viewport'
    );

    const track = ticker.querySelector(
      TRACK_SELECTOR
    );

    const originalUnit = ticker.querySelector(
      UNIT_SELECTOR
    );

    if (
      !viewport ||
      !track ||
      !originalUnit
    ) {
      return;
    }

    /*
     * Save one clean ticker unit before cloning it.
     */
    const unitMarkup =
      originalUnit.outerHTML;

    /*
     * Remove any accidental previously generated clones.
     */
    track.innerHTML = unitMarkup;

    /*
     * Add enough ticker units to make the first half wider
     * than the viewport. This prevents blank spaces.
     */
    const buffer = 60;

    while (
      track.scrollWidth <
      viewport.clientWidth + buffer
    ) {
      track.insertAdjacentHTML(
        'beforeend',
        unitMarkup
      );
    }

    /*
     * Measure the completed first half.
     */
    const firstHalfMarkup =
      track.innerHTML;

    const firstHalfWidth =
      track.scrollWidth;

    /*
     * Duplicate the first half exactly once.
     */
    track.insertAdjacentHTML(
      'beforeend',
      firstHalfMarkup
    );

    /*
     * Tell CSS the exact distance required for a
     * seamless animation loop.
     */
    track.style.setProperty(
      '--hh-ft-shift',
      `${firstHalfWidth}px`
    );

    ticker.dataset.hhFeatureTickerReady =
      'true';
  }

  /**
   * Initializes all tickers within a root element.
   */
  function initializeFeatureTickers(
    root = document
  ) {
    const tickers = [];

    if (
      root.matches &&
      root.matches(TICKER_SELECTOR)
    ) {
      tickers.push(root);
    }

    if (root.querySelectorAll) {
      tickers.push(
        ...root.querySelectorAll(
          TICKER_SELECTOR
        )
      );
    }

    tickers.forEach(
      initializeFeatureTicker
    );
  }

  /**
   * Standard page load.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeFeatureTickers(document);
      }
    );
  } else {
    initializeFeatureTickers(document);
  }

  /**
   * Shopify theme-editor section reload.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeFeatureTickers(event.target);
    }
  );
})();

/* =========================================================
   FEATURE BENEFITS TICKER — END
========================================================= */







/* =========================================================
   STICKY DISCOUNT BAR — START

   Behavior:
   - Appears after 10% of the total scrollable page is passed
   - Hides again when the visitor scrolls above that point
   - Desktop and tablet only
   - Supports Shopify theme-editor section reloads
========================================================= */

(() => {
  'use strict';

  const BAR_SELECTOR = '[data-hh-sticky-offer-bar]';
  const VISIBLE_CLASS = 'is-visible';
  const MOBILE_BREAKPOINT = 600;
  const SCROLL_THRESHOLD = 0.10;

  function initializeStickyOfferBar(bar) {
    if (
      !bar ||
      bar.dataset.hhStickyOfferReady === 'true'
    ) {
      return;
    }

    function getScrollProgress() {
      const documentElement = document.documentElement;

      const scrollTop =
        window.scrollY ||
        documentElement.scrollTop ||
        0;

      const scrollableHeight =
        documentElement.scrollHeight -
        window.innerHeight;

      if (scrollableHeight <= 0) {
        return 0;
      }

      return scrollTop / scrollableHeight;
    }

    function updateStickyBar() {
      const isMobile =
        window.innerWidth < MOBILE_BREAKPOINT;

      const hasPassedThreshold =
        getScrollProgress() >= SCROLL_THRESHOLD;

      if (!isMobile && hasPassedThreshold) {
        bar.classList.add(VISIBLE_CLASS);
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove(VISIBLE_CLASS);
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    let ticking = false;

    function requestUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;

      window.requestAnimationFrame(() => {
        updateStickyBar();
        ticking = false;
      });
    }

    bar.setAttribute('aria-hidden', 'true');

    window.addEventListener(
      'scroll',
      requestUpdate,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      requestUpdate
    );

    updateStickyBar();

    bar.dataset.hhStickyOfferReady = 'true';
  }

  function initializeStickyOfferBars(root = document) {
    const bars = [];

    if (
      root.matches &&
      root.matches(BAR_SELECTOR)
    ) {
      bars.push(root);
    }

    if (root.querySelectorAll) {
      bars.push(
        ...root.querySelectorAll(BAR_SELECTOR)
      );
    }

    bars.forEach(initializeStickyOfferBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeStickyOfferBars(document);
      }
    );
  } else {
    initializeStickyOfferBars(document);
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeStickyOfferBars(event.target);
    }
  );
})();

/* =========================================================
   STICKY DISCOUNT BAR — END
========================================================= */





/* =========================================================
   SECOND INGREDIENT ACCORDION — START

   Features:
   - Independent from the original bottle accordion
   - Smooth open and close animation
   - Only one item remains open at a time
   - Clicking an open item closes it
   - Supports multiple copies of this new accordion
   - Supports Shopify theme-editor reloads
========================================================= */

(() => {
  'use strict';

  const ACCORDION_SELECTOR =
    '[data-hh-secondary-ingredients]';

  const TRIGGER_SELECTOR =
    '.hh-secondary-ingredient-trigger';

  const PANEL_SELECTOR =
    '.hh-secondary-ingredient-panel';

  /**
   * Finds the panel controlled by a trigger.
   */
  function getSecondaryPanel(accordion, trigger) {
    const panelId =
      trigger.getAttribute('aria-controls');

    if (!panelId) {
      return null;
    }

    return accordion.querySelector(
      `[id="${panelId}"]`
    );
  }

  /**
   * Opens one ingredient.
   */
  function openSecondaryIngredient(
    trigger,
    panel
  ) {
    if (!trigger || !panel) {
      return;
    }

    trigger.setAttribute(
      'aria-expanded',
      'true'
    );

    panel.classList.add('is-open');
    panel.style.height = '0px';

    window.requestAnimationFrame(() => {
      panel.style.height =
        `${panel.scrollHeight}px`;
    });

    function handleOpenEnd(event) {
      if (
        event.propertyName !== 'height' ||
        trigger.getAttribute(
          'aria-expanded'
        ) !== 'true'
      ) {
        return;
      }

      /*
       * Auto height allows content to adapt when
       * text wrapping changes.
       */
      panel.style.height = 'auto';

      panel.removeEventListener(
        'transitionend',
        handleOpenEnd
      );
    }

    panel.addEventListener(
      'transitionend',
      handleOpenEnd
    );
  }

  /**
   * Closes one ingredient.
   */
  function closeSecondaryIngredient(
    trigger,
    panel
  ) {
    if (!trigger || !panel) {
      return;
    }

    trigger.setAttribute(
      'aria-expanded',
      'false'
    );

    panel.style.height =
      `${panel.scrollHeight}px`;

    /*
     * Force the browser to register the current
     * height before transitioning to zero.
     */
    panel.getBoundingClientRect();

    panel.style.height = '0px';
    panel.classList.remove('is-open');
  }

  /**
   * Initializes one secondary accordion.
   */
  function initializeSecondaryAccordion(
    accordion
  ) {
    if (
      !accordion ||
      accordion.dataset
        .hhSecondaryIngredientsReady === 'true'
    ) {
      return;
    }

    const triggers = Array.from(
      accordion.querySelectorAll(
        TRIGGER_SELECTOR
      )
    );

    /*
     * Set all items to a reliable closed state.
     */
    triggers.forEach((trigger) => {
      const panel = getSecondaryPanel(
        accordion,
        trigger
      );

      trigger.setAttribute(
        'aria-expanded',
        'false'
      );

      if (panel) {
        panel.classList.remove('is-open');
        panel.style.height = '0px';
      }
    });

    /*
     * Use one delegated click listener.
     */
    accordion.addEventListener(
      'click',
      (event) => {
        const trigger = event.target.closest(
          TRIGGER_SELECTOR
        );

        if (
          !trigger ||
          !accordion.contains(trigger)
        ) {
          return;
        }

        const selectedPanel =
          getSecondaryPanel(
            accordion,
            trigger
          );

        if (!selectedPanel) {
          console.warn(
            'Secondary ingredient panel not found:',
            trigger.getAttribute(
              'aria-controls'
            )
          );

          return;
        }

        const selectedWasOpen =
          trigger.getAttribute(
            'aria-expanded'
          ) === 'true';

        /*
         * Close all other items first.
         */
        triggers.forEach(
          (otherTrigger) => {
            if (otherTrigger === trigger) {
              return;
            }

            const otherPanel =
              getSecondaryPanel(
                accordion,
                otherTrigger
              );

            if (
              otherTrigger.getAttribute(
                'aria-expanded'
              ) === 'true'
            ) {
              closeSecondaryIngredient(
                otherTrigger,
                otherPanel
              );
            }
          }
        );

        /*
         * Toggle the selected item.
         */
        if (selectedWasOpen) {
          closeSecondaryIngredient(
            trigger,
            selectedPanel
          );
        } else {
          openSecondaryIngredient(
            trigger,
            selectedPanel
          );
        }
      }
    );

    accordion.dataset
      .hhSecondaryIngredientsReady = 'true';
  }

  /**
   * Initializes all new accordions in a root.
   */
  function initializeSecondaryAccordions(
    root = document
  ) {
    const accordions = [];

    if (
      root.matches &&
      root.matches(ACCORDION_SELECTOR)
    ) {
      accordions.push(root);
    }

    if (root.querySelectorAll) {
      accordions.push(
        ...root.querySelectorAll(
          ACCORDION_SELECTOR
        )
      );
    }

    accordions.forEach(
      initializeSecondaryAccordion
    );
  }

  /**
   * Standard page initialization.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeSecondaryAccordions(
          document
        );
      }
    );
  } else {
    initializeSecondaryAccordions(document);
  }

  /**
   * Shopify theme-editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeSecondaryAccordions(
        event.target
      );
    }
  );

  /**
   * Keep open panels correctly sized after resize.
   */
  window.addEventListener('resize', () => {
    document
      .querySelectorAll(
        `${ACCORDION_SELECTOR} ${TRIGGER_SELECTOR}[aria-expanded="true"]`
      )
      .forEach((trigger) => {
        const accordion = trigger.closest(
          ACCORDION_SELECTOR
        );

        const panel = getSecondaryPanel(
          accordion,
          trigger
        );

        if (panel) {
          panel.style.height = 'auto';
        }
      });
  });
})();

/* =========================================================
   SECOND INGREDIENT ACCORDION — END
========================================================= */







/* =========================================================
   CUSTOMER REVIEWS SHOW MORE — START

   Behavior:
   - Image reviews are visible by default
   - Text-only reviews are hidden initially
   - Clicking the button reveals all text-only reviews
   - Clicking again hides the text-only reviews
   - Supports multiple review sections
   - Supports Shopify theme-editor reloads
========================================================= */

(() => {
  'use strict';

  const SECTION_SELECTOR =
    '[data-hh-customer-reviews]';

  const ADDITIONAL_REVIEW_SELECTOR =
    '[data-hh-additional-review]';

  const BUTTON_SELECTOR =
    '[data-hh-show-reviews]';

  const BUTTON_WRAPPER_SELECTOR =
    '[data-hh-reviews-button-wrapper]';

  /**
   * Initializes one customer reviews section.
   */
  function initializeCustomerReviews(section) {
    if (
      !section ||
      section.dataset.hhCustomerReviewsReady === 'true'
    ) {
      return;
    }

    const additionalReviews = Array.from(
      section.querySelectorAll(
        ADDITIONAL_REVIEW_SELECTOR
      )
    );

    const button = section.querySelector(
      BUTTON_SELECTOR
    );

    const buttonWrapper = section.querySelector(
      BUTTON_WRAPPER_SELECTOR
    );

    /*
     * Hide the button when no additional reviews exist.
     */
    if (
      additionalReviews.length === 0 ||
      !button
    ) {
      if (buttonWrapper) {
        buttonWrapper.hidden = true;
      }

      return;
    }

    let reviewsAreExpanded = false;

    /**
     * Reveals every text-only review.
     */
    function showAdditionalReviews() {
      reviewsAreExpanded = true;

      additionalReviews.forEach(
        (review, index) => {
          review.hidden = false;

          review.classList.remove(
            'is-revealing'
          );

          window.requestAnimationFrame(() => {
            window.setTimeout(() => {
              review.classList.add(
                'is-revealing'
              );
            }, index * 40);
          });
        }
      );

      button.textContent =
        'Show Fewer Reviews';

      button.setAttribute(
        'aria-expanded',
        'true'
      );
    }

    /**
     * Hides every text-only review.
     */
    function hideAdditionalReviews() {
      reviewsAreExpanded = false;

      additionalReviews.forEach(
        (review) => {
          review.hidden = true;

          review.classList.remove(
            'is-revealing'
          );
        }
      );

      button.textContent =
        'Show More Reviews';

      button.setAttribute(
        'aria-expanded',
        'false'
      );

      /*
       * Bring the visible image reviews back into view
       * after collapsing the longer section.
       */
      const sectionTop =
        section.getBoundingClientRect().top +
        window.scrollY;

      window.scrollTo({
        top: Math.max(sectionTop - 20, 0),
        behavior: 'smooth'
      });
    }

    /**
     * Toggles between expanded and collapsed states.
     */
    button.addEventListener(
      'click',
      () => {
        if (reviewsAreExpanded) {
          hideAdditionalReviews();
        } else {
          showAdditionalReviews();
        }
      }
    );

    /*
     * Establish the correct initial state.
     */
    additionalReviews.forEach(
      (review) => {
        review.hidden = true;

        review.classList.remove(
          'is-revealing'
        );
      }
    );

    button.textContent =
      'Show More Reviews';

    button.setAttribute(
      'aria-expanded',
      'false'
    );

    section.dataset.hhCustomerReviewsReady =
      'true';
  }

  /**
   * Initializes all customer review sections inside a root.
   */
  function initializeCustomerReviewSections(
    root = document
  ) {
    const sections = [];

    if (
      root.matches &&
      root.matches(SECTION_SELECTOR)
    ) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections.push(
        ...root.querySelectorAll(
          SECTION_SELECTOR
        )
      );
    }

    sections.forEach(
      initializeCustomerReviews
    );
  }

  /**
   * Standard page initialization.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeCustomerReviewSections(
          document
        );
      }
    );
  } else {
    initializeCustomerReviewSections(
      document
    );
  }

  /**
   * Shopify theme-editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeCustomerReviewSections(
        event.target
      );
    }
  );
})();

/* =========================================================
   CUSTOMER REVIEWS SHOW MORE — END
========================================================= */





/* =========================================================
   SUMMER SALE COUNTDOWN — START

   Behavior:
   - Starts at two hours for each visitor
   - Persists through page refreshes
   - Restarts at two hours when it reaches zero
   - Supports multiple copies of the countdown
========================================================= */

(() => {
  'use strict';

  const COUNTDOWN_SELECTOR =
    '[data-hh-summer-countdown]';

  const STORAGE_KEY =
    'hhSummerSaleCountdownEnd';

  const COUNTDOWN_DURATION =
    2 * 60 * 60 * 1000;

  function getCountdownEndTime() {
    const savedEndTime = Number(
      window.localStorage.getItem(STORAGE_KEY)
    );

    if (
      Number.isFinite(savedEndTime) &&
      savedEndTime > Date.now()
    ) {
      return savedEndTime;
    }

    const newEndTime =
      Date.now() + COUNTDOWN_DURATION;

    window.localStorage.setItem(
      STORAGE_KEY,
      String(newEndTime)
    );

    return newEndTime;
  }

  let countdownEndTime =
    getCountdownEndTime();

  function updateCountdowns() {
    let remainingTime =
      countdownEndTime - Date.now();

    if (remainingTime <= 0) {
      countdownEndTime =
        Date.now() + COUNTDOWN_DURATION;

      window.localStorage.setItem(
        STORAGE_KEY,
        String(countdownEndTime)
      );

      remainingTime = COUNTDOWN_DURATION;
    }

    const hours = Math.floor(
      remainingTime / (1000 * 60 * 60)
    );

    const minutes = Math.floor(
      (
        remainingTime %
        (1000 * 60 * 60)
      ) /
      (1000 * 60)
    );

    const seconds = Math.floor(
      (
        remainingTime %
        (1000 * 60)
      ) /
      1000
    );

    document
      .querySelectorAll(COUNTDOWN_SELECTOR)
      .forEach((countdown) => {
        const hoursElement =
          countdown.querySelector(
            '[data-hh-sale-hours]'
          );

        const minutesElement =
          countdown.querySelector(
            '[data-hh-sale-minutes]'
          );

        const secondsElement =
          countdown.querySelector(
            '[data-hh-sale-seconds]'
          );

        if (
          !hoursElement ||
          !minutesElement ||
          !secondsElement
        ) {
          return;
        }

        hoursElement.textContent =
          String(hours).padStart(2, '0');

        minutesElement.textContent =
          String(minutes).padStart(2, '0');

        secondsElement.textContent =
          String(seconds).padStart(2, '0');
      });
  }

  updateCountdowns();

  window.setInterval(
    updateCountdowns,
    1000
  );
})();

/* =========================================================
   SUMMER SALE COUNTDOWN — END
========================================================= */



/* =========================================================
   SHIPPING LOCATION PILL — START

   Behavior:
   - Uses today's date as the shipping date
   - Detects approximate city and country from the visitor's IP
   - Uses a backup location service if the first request fails
   - Falls back to "your location" if both services fail
   - Supports multiple shipping pills on the same page
========================================================= */

(() => {
  'use strict';

  const PILL_SELECTOR = '[data-hh-shipping-pill]';
  const TEXT_SELECTOR = '[data-hh-shipping-text]';

  function formatShippingDate(date) {
    return date.toLocaleDateString(undefined, {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    });
  }

  function updateShippingText(city, country) {
    const shippingDate = formatShippingDate(
      new Date()
    );

    let message = `Ships by ${shippingDate} to your location`;

    if (city && country) {
      message =
        `Ships by ${shippingDate} to ${city}, ${country}`;
    } else if (country) {
      message =
        `Ships by ${shippingDate} to ${country}`;
    }

    document
      .querySelectorAll(PILL_SELECTOR)
      .forEach((pill) => {
        const textElement =
          pill.querySelector(TEXT_SELECTOR);

        if (textElement) {
          textElement.textContent = message;
        }
      });
  }

  async function requestPrimaryLocation() {
    const response = await fetch(
      'https://ipwho.is/',
      {
        method: 'GET',
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Primary geolocation request failed.'
      );
    }

    const data = await response.json();

    if (!data || data.success === false) {
      throw new Error(
        'Primary geolocation response was invalid.'
      );
    }

    return {
      city: data.city || '',
      country: data.country || ''
    };
  }

  async function requestBackupLocation() {
    const response = await fetch(
      'https://ipapi.co/json/',
      {
        method: 'GET',
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Backup geolocation request failed.'
      );
    }

    const data = await response.json();

    return {
      city: data.city || '',
      country:
        data.country_name ||
        data.country ||
        ''
    };
  }

  async function initializeShippingPills() {
    if (
      !document.querySelector(PILL_SELECTOR)
    ) {
      return;
    }

    /*
     * Show a useful fallback immediately while
     * the location request is loading.
     */
    updateShippingText('', '');

    try {
      const location =
        await requestPrimaryLocation();

      updateShippingText(
        location.city,
        location.country
      );
    } catch (primaryError) {
      try {
        const location =
          await requestBackupLocation();

        updateShippingText(
          location.city,
          location.country
        );
      } catch (backupError) {
        updateShippingText('', '');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeShippingPills
    );
  } else {
    initializeShippingPills();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeShippingPills
  );
})();
document.addEventListener('DOMContentLoaded', function () {
  const plans = document.querySelectorAll('.plan-card');
  const subscriptionInfoBar = document.querySelector('.hh-subscription-info-bar');

  if (!plans.length || !subscriptionInfoBar) return;

  function updateSubscriptionInfoBar(selectedPlan) {
    const checkoutUrl = selectedPlan.dataset.checkoutUrl || '';

    const isOneTimePurchase =
      checkoutUrl.includes('/cart/54303341314358:1') ||
      !checkoutUrl.includes('selling_plan=');

    subscriptionInfoBar.style.display = isOneTimePurchase ? 'none' : 'flex';
  }

  plans.forEach(function (plan) {
    plan.addEventListener('click', function () {
      updateSubscriptionInfoBar(plan);
    });
  });

  const activePlan =
    document.querySelector('.plan-card.active') || plans[0];

  updateSubscriptionInfoBar(activePlan);
});
/* =========================================================
   SHIPPING LOCATION PILL — END
========================================================= */